import { useQuery } from "react-query";
import { LoadingDots } from "web-ui";

import { getPerAppStoreReleaseStatus } from "api/dashboardBackend";
import { useSource } from "components/SourceContext";
import strings from "components/common/Common.strings.json";
import styles from "components/dashboard/release-card/per-app-store-release-status/PerAppStoreReleaseStatus.module.scss";
import ReleaseStatusIcon from "components/dashboard/release-card/per-app-store-release-status/ReleaseStatusIcon";
import { type PlatformId } from "util/platform";

interface Props {
  platformId: PlatformId;
  versionString: string;
}

const PerAppStoreReleaseStatus = ({ platformId, versionString }: Props) => {
  const source = useSource();
  const params = new URLSearchParams();
  if (source !== null) {
    params.set("source", source);
  }
  const {
    data: data,
    isError: isError,
    isLoading: isLoading,
  } = useQuery({
    queryFn: () =>
      getPerAppStoreReleaseStatus(platformId, versionString, params),
    queryKey: [platformId, versionString, "per-app-store-release-status"],
  });

  if (isError) {
    return <div>{strings.data_fetch_error}</div>;
  }

  if (!isError && !isLoading && !data) {
    return <div>{strings.no_data}</div>;
  }

  if (isLoading) {
    return <LoadingDots manualPositioning={true} type="screen-white" />;
  }

  const statuses = data.map(appStoreReleaseStatus => (
    <div key={appStoreReleaseStatus.app_store} style={{ position: "relative" }}>
      <ReleaseStatusIcon appStoreReleaseStatus={appStoreReleaseStatus} />
    </div>
  ));

  return <div className={styles.container}>{statuses}</div>;
};

export default PerAppStoreReleaseStatus;
